import {csvFormatRows, csvParseRows} from 'd3-dsv'

export function formatCSV(rows) {
  return csvFormatRows(rows)
}

export function parseCSV(text = '') {
  const rows = csvParseRows(text.replace(/(\n)*$/, ''))

  return rows
}
